import { Bx } from '@curry-group/mui-curcuma';
import Badge from '@material-ui/core/Badge';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { DeactivatedIcon } from './index';

export interface IAvatarWithDeactivatedBadgeProps {
  avatar: React.ReactElement;
  deactivated?: boolean;
}

const BADGE_SIZE = 20;

// MUI's <Badge> wraps `badgeContent` in a `.MuiBadge-badge` span that has its
// own background colour, padding, min-width and rectangular border-radius —
// which would show as coloured corners around our circular badgeContent.
// Reset those so the visible shape is exactly the inner circular Bx.
const useBadgeStyles = makeStyles({
  deactivatedBadge: {
    backgroundColor: 'transparent',
    padding: 0,
    minWidth: 0,
    height: 'auto',
    borderRadius: '50%',
  },
});

/**
 * Wraps an avatar with a circular white-background "deactivated" badge in the
 * bottom-right. Pass `deactivated={false}` and the avatar is returned
 * untouched.
 */
export const AvatarWithDeactivatedBadge: React.FC<IAvatarWithDeactivatedBadgeProps> = ({
  avatar,
  deactivated,
}) => {
  const classes = useBadgeStyles();
  if (!deactivated) return avatar;
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      title="Inaktiv"
      classes={{ badge: classes.deactivatedBadge }}
      badgeContent={
        <Bx
          bgcolor="background.paper"
          borderRadius={'full'}
          display="flex"
          alignItems="center"
          justifyContent="center"
          width={BADGE_SIZE}
          height={BADGE_SIZE}
          style={{ fontSize: BADGE_SIZE, lineHeight: 1 }}
        >
          <DeactivatedIcon title="Inaktiv" />
        </Bx>
      }
    >
      {avatar}
    </Badge>
  );
};
